import axios from "axios";
import { getSimCards } from "./simcards";

export const getDevices = async imeiCodes => {
  const response = await axios.get(
    `/api/devices?imeiCodes=${imeiCodes.join("|")}`
  );
  return response.data;
};

export const importDevices = async devices => {
  const response = await axios.post(`/api/devices`, { devices });
  return response.data;
};

export const createDevice = async device => {
  const response = await axios.put(`/api/devices`, { device });
  return response.data;
};

export const updateDevice = async device => {
  const response = await axios.patch(`/api/devices`, { device });
  return response.data;
};

export const getDevice = async id => {
  const response = await axios.get(`/api/devices/${id}`);
  return response.data;
};

export const pairData = async scans => {
  const response = await axios.post(`/api/pair-devices`, { scans });
  return response.data;
};

export const getHistory = async id => {
  const response = await axios.get(`/api/deviceshistory/${id}`);
  return response.data;
};

export const unlink = async (sn, iccid) => {
  const response = await axios.patch(`/api/unlinkdevice/${sn}/${iccid}`);
  return response.data;
};

export const getParingDataError = async (scans, getDeviceId, getSimId) => {
  if (!scans.length) return {};
  const data = await Promise.all([
    getDevices(scans.map(el => el.device)),
    getSimCards(scans.map(el => el.sim))
  ]);

  return scans.reduce((acc, entry, i) => {
    const sim = data[1].find(el => String(el.iccid) === String(entry.sim));
    const sat = data[0].find(el => String(el.imei) === String(entry.device));
    const devId = getDeviceId(i);
    const simId = getSimId(i);
    if (!sat || sat.status !== "inserito") {
      acc[
        devId
      ] = `questo dispositivo non esiste oppure é giá associato ad una sim`;
    }

    if (!sim || sim.status !== "inserito") {
      acc[
        simId
      ] = `questa sim non esiste oppure é giá associata ad un dispositivo`;
    }
    return acc;
  }, {});
};

export const getDeliveryValidation = async (scans, getDeviceId) => {
  if (!scans.length) return {};
  const devices = await getDevices(scans);
  return scans.reduce((acc, entry, i) => {
    const sat = devices.find(el => String(el.imei) === String(entry));
    const devId = getDeviceId(i);
    if (!sat || sat.status !== "associato") {
      acc[
        devId
      ] = `Questo dispositivo non esiste oppure non é in stato 'associato' (pronto per la spedizione)`;
    }
    return acc;
  }, {});
};

export const getDeviceByImeiEnd = async (imeiEnd) => {
  const response = await axios.get(`/api/deviceimeiend/${imeiEnd}`);
  return response.data;
}

export const getDeviceByTicket = async (ticket) => {
  const response = await axios.get(`/api/deviceticket/${ticket}`);
  return response.data;
}

export const getDeviceByPlate = async (plate) => {
  const response = await axios.get(`/api/deviceplate/${plate}`);
  return response.data;
}

export const deleteDevice = async id => {
  const response = await axios.delete(`/api/devices/${id}`);
  return response.data;
};
